module.exports = __webpack_public_path__ + "static/media/fish-bg.a1e4c817.png";